import {assertAndContinue} from 'Asserts';
import APIUtil from 'util/APIUtil';
import {assertNever} from 'util/Types';

import {ViewContext, ViewType} from './ViewStateTypes';

export const MAIN_ANALYTICS_DASHBOARD_VIEW_CONTEXT: ViewContext = {
  viewType: ViewType.MAIN_ANALYTICS_DASHBOARD,
};

export const DEFAULT_DASHBOARD_VIEW_STATE_ID = getAnalyticsDashboardViewStateId(
  'axdash_UNKNOWN',
  MAIN_ANALYTICS_DASHBOARD_VIEW_CONTEXT
);

export function getAnalyticsDashboardViewStateId(
  analyticsDashboardId: string,
  viewContext: ViewContext
): string {
  switch (viewContext.viewType) {
    case ViewType.EMBEDDED_ANALYTICS_DASHBOARD:
      return `AnalyticsDashboardViewState-${viewContext.viewType}-${analyticsDashboardId}-${viewContext.embeddingItemId}`;
    case ViewType.MAIN_ANALYTICS_DASHBOARD:
      return `AnalyticsDashboardViewState-${viewContext.viewType}-${analyticsDashboardId}`;
    default:
      assertAndContinue(false, `Unexpected view state context: ${assertNever(viewContext)}.`);
      return `AnalyticsDashboardViewState-UNKNOWN-${analyticsDashboardId}`;
  }
}

export function isAnalyticsDashboardViewStateId(maybeAnalyticsDashboardId: string): boolean {
  const idParts = maybeAnalyticsDashboardId.split('-');
  return (
    idParts[0] === 'AnalyticsDashboardViewState' &&
    ['UNKNOWN', ...Object.keys(ViewType)].includes(idParts[1]) &&
    APIUtil.isAnalyticsDashboard(idParts[2]) &&
    (idParts.length === 3 || (idParts.length === 4 && APIUtil.apiIdToMaybeType(idParts[3]) != null))
  );
}
